module.exports = __webpack_public_path__ + "static/info-circle.e4603ac255becf575f24985266a1a1b6.svg";